export default __webpack_public_path__ + "static/media/landscape3-MULTIPLY-shadows.9ffeb357.png";